import { ColorPicker as AntColorPicker } from 'antd'
import type { ColorPickerProps } from 'antd'

// Wrapper ColorPicker: features/pages/components không import trực tiếp 'antd'.
// Pass-through, không thêm hành vi.
export default function UiColorPicker(props: ColorPickerProps) {
  return <AntColorPicker {...props} />
}
